// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatChatListProjectsEmpty-moduleempty__NY1qK";
export { _1 as "empty" }
